import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { SafeImage } from "@/components/SafeImage";
import { CATEGORIES } from "@/data/content";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Categories() {
  usePageMeta(
    "Product Categories | Chhannulal & Brothers (CLB)",
    "Explore paints, pipes & fittings, luxury bathware, water storage tanks, kitchen sinks, construction chemicals, white cement, wall putty and tile adhesives at Chhannulal & Brothers."
  );
  return (
    <main>
      <section className="bg-darknavy pb-20 pt-36 text-cream lg:pb-28 lg:pt-44">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <Reveal>
            <Overline dark>Products</Overline>
            <h1 className="mt-4 font-display text-4xl font-light tracking-tight sm:text-6xl">Explore Our Categories</h1>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-cream/70">
              Eight categories. Trusted brands. One roof. Whatever stage your project is at, CLB has the materials to move it forward.
            </p>
          </Reveal>
        </div>
      </section>
      <section className="bg-cream py-20 lg:py-28" data-testid="categories-grid">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {CATEGORIES.map((c, i) => (
              <Reveal key={c.slug} delay={(i % 3) * 0.08}>
                <Link to={`/categories/${c.slug}`} data-testid={`categories-page-card-${c.slug}`} className="group block border border-darknavy/10 bg-white transition-all duration-500 hover:border-navy hover:shadow-[0_20px_50px_rgba(4,57,94,0.12)]">
                  <div className="relative h-56 overflow-hidden">
                    <SafeImage src={c.image} alt={`${c.name} at Chhannulal & Brothers`} className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
                    <span className="absolute left-4 top-4 bg-darknavy/85 px-2.5 py-1 font-display text-[10px] font-semibold tracking-[0.25em] text-gold backdrop-blur">{String(i + 1).padStart(2, "0")}</span>
                  </div>
                  <div className="p-6">
                    <h2 className="font-display text-xl font-medium text-darknavy">{c.name}</h2>
                    <p className="mt-2 text-sm leading-relaxed text-darknavy/60">{c.short}</p>
                    {c.brands.length > 0 && (
                      <p className="mt-3 text-xs uppercase tracking-[0.15em] text-aqua">{c.brands.join(" · ")}</p>
                    )}
                    <span className="mt-4 inline-flex items-center gap-2 font-display text-xs font-semibold uppercase tracking-[0.2em] text-navy transition-colors duration-300 group-hover:text-gold">
                      Explore Category <ArrowUpRight className="h-4 w-4" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
